import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { useDispatch } from "react-redux";

import CheckoutFinish from "../containers/Renewal/CheckoutFinish";
import Checkout from "../containers/Renewal/Checkout";
import Complete from "../containers/Renewal/Complete";
import HeaderNew from "../containers/Renewal/HeaderNew";
import Renewal from "../containers/Renewal/Renewal";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const AppCustomQuote = (props) => {
	const {
		renewalId,
		stripePubKey,
		customerName,
		helloSignCid,
		orderHashId,
		allowCreditCardPayments,
	} = props;
	const dispatch = useDispatch();

	const stripePromise = loadStripe(stripePubKey);

	useEffect(() => {
		if (renewalId) {
			dispatch({ type: "SET_RENEWAL_ID", payload: renewalId });

			fetch(`/api/v2/quotes/${renewalId}`)
				.then((res) => res.json())
				.then((res) => {
					dispatch({
						type: "SET_INITIAL_QUOTE_DATA",
						payload: res.quote,
					});
				});
		}
	}, [renewalId]);

	return (
		<>
			<HeaderNew customerName={customerName} />
			<Switch>
				<Route exact path={`/v3/custom_quote/${orderHashId}/finish`}>
					<Renewal
						quoteBuilder={true}
						customerName={customerName}
						orderHashId={orderHashId}
					/>
				</Route>
				<Route exact path={`/v3/custom_quote/${orderHashId}/checkout`}>
					<Elements stripe={stripePromise}>
						<Checkout
							helloSignCid={helloSignCid}
							allowCreditCardPayments={allowCreditCardPayments}
						/>
					</Elements>
				</Route>
				<Route path={`/v3/renewals/${renewalId}/react/complete`}>
					<Complete />
				</Route>
			</Switch>
		</>
	);
};

export default AppCustomQuote;
